import { isEqual, get, deepMix } from '@antv/util';
import { TOOLTIP_CSS_CONST } from '@antv/component';
import { Point } from '../../../../interface';
import Action from '../../base';
import { HtmlTooltip } from '../../../../dependents';

/**
 * ç¨äºç»ä»¶ææ¬çç¥åéè¦å±ç¤ºå®æ´ä¿¡æ¯ç Tooltip Action
 * @ignore
 */
export default class EllipsisText extends Action {
  private timeStamp: number = 0;
  private location: Point;
  private tooltip;

  public destroy() {
    super.destroy();
    this.tooltip && this.tooltip.destroy();
  }

  /**
   * æ¾ç¤º Tooltip
   * @returns
   */
  public show() {
    const context = this.context;
    const ev = context.event;
    const lastTimeStamp = this.timeStamp;
    const timeStamp = +new Date();

    if (timeStamp - lastTimeStamp > 16) {
      const preLoc = this.location;
      const curLoc = { x: ev.x, y: ev.y };
      if (!preLoc || !isEqual(preLoc, curLoc)) {
        this.showTooltip(curLoc);
      }
      this.timeStamp = timeStamp;
      this.location = curLoc;
    }
  }

  /**
   * éè Tooltipã
   * @returns
   */
  public hide() {
    this.hideTooltip();
    this.location = null;
  }

  protected showTooltip(curLoc: Point) {
    const context = this.context;
    const ev = context.event;
    const target = ev.target;

    if (target && target.get('tip')) {
      if (!this.tooltip) {
        this.renderTooltip(); // å»¶è¿çæ
      }
      const tipContent = target.get('tip');
      // å±ç¤º tooltip
      this.tooltip.update({
        title: tipContent,
        ...curLoc,
      });
      this.tooltip.show();
    }
  }

  protected hideTooltip() {
    this.tooltip && this.tooltip.hide();
  }

  private renderTooltip() {
    const view = this.context.view;
    const canvas = view.canvas;

    const region = {
      start: { x: 0, y: 0 },
      end: { x: canvas.get('width'), y: canvas.get('height') },
    };

    const theme = view.getTheme();
    const tooltipStyles = get(theme, ['components', 'tooltip', 'domStyles'], {}); // è·å tooltip æ ·å¼
    const tooltip = new HtmlTooltip({
      parent: canvas.get('el').parentNode,
      region,
      visible: false,
      crosshairs: null,
      domStyles: {
        ...deepMix({}, tooltipStyles, {
          // è¶é¿çæ¶åï¼tooltip tip æå¤§å®½åº¦ä¸º 50%ï¼ç¶åå¯ä»¥æ¢è¡
          [TOOLTIP_CSS_CONST.CONTAINER_CLASS]: { 'max-width': '50%' },
          [TOOLTIP_CSS_CONST.TITLE_CLASS]: { 'word-break': 'break-all' },
        }),
      },
    });
    tooltip.init();
    tooltip.setCapture(false); // ä¸åè®¸æè·äºä»¶
    this.tooltip = tooltip;
  }
}
